var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("tr", [
    _c(
      "td",
      {
        staticClass: "bg-gray-100 text-center text-gray-400 py-6",
        attrs: { colspan: _vm.colSpan },
      },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }